<div *ngIf="!isHandset else mobileTemplate">  <div class="form-group row align-items-center">
    <label for="luSourceDropdown" class="col-form-label col-2 label">
      Source: 
    </label>
    <div class="col-6 mb-4 d-flex align-items-center">
      <select class="form-control me-2" style="max-width: 500px;" required #luSourceDropdown name="luSourceDropdown" id="luSourceDropdown" [(ngModel)]="luSourceSelection" [disabled]="working" (ngModelChange)="changeSource($event)">
        <option [ngValue]="null">Choose a source</option>
        <option *ngFor="let s of sourceData" [ngValue]="s">{{ s.source }}</option>
      </select>
      <img *ngIf="!working && luSourceSelection && luSourceSelection.logoPath" [src]="luSourceSelection.logoPath" class="source-logo me-2">
      <div *ngIf="!callNumberData.length && !working" class="flex-grow-1">
        <div class="alert alert-warning mb-0" role="alert">
          <i class="fal fa-exclamation-triangle me-1"></i>Sorry, there is no Call # data associated with that Source.
        </div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label for="callL1" class="col-form-label col-2 label" style="width: auto;">Call numbers: </label>
    <!--
    <select [disabled]="!callNumberData.length" required name="callL1" id="callL1" class="form-control col-sm-2" [(ngModel)]="callNumberL1Selection" (change)="changeCallNumberSelections()">
      <option [ngValue]="null">Choose call #</option>
      <option *ngFor="let c of callNumberL1DisplayData" [ngValue]="c.callNumberL1">
    </select>
    -->
      <mat-select class="form-control col-sm-2 matSelect" [disabled]="callNumberL1DisplayData.length == 0" [(ngModel)]="callNumberL1Selection" (change)="changeCallNumberSelections()">
        <mat-option [value]="null" (click)="changeCallNumberSelections()">Choose call #</mat-option>
        <mat-option *ngFor="let c of callNumberL1DisplayData" [value]="c.callNumberL1" (click)="changeCallNumberSelections()" style="min-height: fit-content; text-wrap: initial;" class="multiline-mat-option">
          <div style="min-height: 3em;">
            <h6 style="margin-bottom: 0em;">{{ c.callNumberL1 }}</h6>
            <p style="text-wrap: always;  margin-bottom: 0;" *ngIf="c.description != null">{{ " " + elipseDescription(c,1) }}</p>
          </div>
        </mat-option>
      </mat-select>
    <label style="width: auto;">&mdash;</label>
    <!--
    <select [disabled]="!callNumberL2Data.length" name="callL2" id="callL2" class="form-control col-sm-2"
      [(ngModel)]="callNumberL2Selection" (change)="changeCallNumberSelections()">
      <option [ngValue]="null"> {{ callNumberL2Data.length ? 'All' : '--' }} </option>
      
        <option *ngFor="let c of callNumberL2Data" [ngValue]="c.callNumberL2">{{ c.callNumberL2 + " " + c.descriptionL2 }}</option>
      
    </select>
    -->
      <mat-select class="form-control col-sm-2 matSelect" [(ngModel)]="callNumberL2Selection" [disabled]="callNumberL2Data.length == 0" (change)="changeCallNumberSelections()">
        <mat-option [ngValue]="null" (click)="changeCallNumberSelections()">Choose call #</mat-option>
        <mat-option *ngFor="let c of callNumberL2Data" [value]="c.callNumberL2" style="min-height: fit-content; text-wrap: initial;" (click)="changeCallNumberSelections()">
          <div style="min-height: 3em;">
            <h6 style="margin-bottom: 0em;">{{ c.callNumberL2 }}</h6>
            <p style="text-wrap: always;  margin-bottom: 0;" *ngIf="c.descriptionL2 != null">{{ " " + elipseDescription(c,2) }}</p>
          </div>
        </mat-option>
      </mat-select>

    <label style="width: auto;">&mdash;</label>
    <!--
    <select [disabled]="!callNumberL3Data.length" name="callL3" id="callL3" class="form-control col-sm-2" [(ngModel)]="callNumberL3Selection"
      (change)="changeCallNumberSelections()">
      <option [ngValue]="null"> {{ callNumberL3Data.length ? 'All' : '--' }} </option>
      
        <option *ngFor="let c of callNumberL3Data" [ngValue]="c.callNumberL3">{{ c.callNumberL3 }}</option>
      
    </select>
  -->
      <mat-select class="form-control col-sm-2 matSelect" [(ngModel)]="callNumberL3Selection" [disabled]="callNumberL3Data.length == 0"  (change)="changeCallNumberSelections()">
        <mat-option [ngValue]="null" (click)="changeCallNumberSelections()">Choose call #</mat-option>
        <mat-option *ngFor="let c of callNumberL3Data" [value]="c.callNumberL3" style="min-height: fit-content; text-wrap: initial;" (click)="changeCallNumberSelections()">
          <div style="min-height: 3em;">
            <h6 style="margin-bottom: 0em;">{{ c.callNumberL3 }}</h6>
            <p style="text-wrap: always;  margin-bottom: 0;" *ngIf="c.descriptionL3 != null">{{ " " + elipseDescription(c,3) }}</p>
          </div>
        </mat-option>
      </mat-select>
    <label style="width: auto;">&mdash;</label>
    <!--
    <select [disabled]="!callNumberL4Data.length" name="callL4" id="callL4" class="form-control col-sm-2" [(ngModel)]="callNumberL4Selection"
      (change)="changeCallNumberSelections()">
      <option [ngValue]="null">{{ callNumberL4Data.length ? 'All' : '--' }}</option>
      
        <option *ngFor="let c of callNumberL4Data" [ngValue]="c.callNumberL4">{{ c.callNumberL4 }}</option>
      
    </select>
  -->
      <mat-select class="form-control col-sm-2 matSelect" [(ngModel)]="callNumberL4Selection" [disabled]="callNumberL4Data.length == 0" (change)="changeCallNumberSelections()">
        <mat-option [ngValue]="null" (click)="changeCallNumberSelections()">Choose call #</mat-option>
        <mat-option *ngFor="let c of callNumberL4Data" [value]="c.callNumberL3" style="min-height: fit-content; text-wrap: initial;" (click)="changeCallNumberSelections()">
          <div style="min-height: 3em;">
            <h6 style="margin-bottom: 0em;">{{ c.callNumberL4 }}</h6>
            <p style="text-wrap: always;  margin-bottom: 0;" *ngIf="c.descriptionL4 != null">{{ " " + elipseDescription(c,4) }}</p>
          </div>
        </mat-option>
      </mat-select>
    <!-- <button class="btn btn-dark btn-sm ml-2" type="button" (click)="emitWithWildcardSelectors()">
      <i class="fal fa-plus-hexagon"></i>
        Go
    </button> -->
  </div>
  <div class="row">
    <label class="col-5 label">
      Description:
    </label>
    <div class="col-7 sourceDescription" *ngIf="chosenSourceCallNumberDescription !== ''; else describePlaceholder" >
      {{ chosenSourceCallNumberDescription }}
    </div>
    <ng-template #describePlaceholder>
      <div class="col-7 sourceDescription text-muted small">
        Choose a call number to see its description.
      </div>
    </ng-template>
  </div>
</div>

<ng-template #mobileTemplate>
  <div class="mainParent">    
    <div class="form-group d-flex align-items-center mb-3">
      <label for="luSourceDropdown" class="label me-3" style="white-space: nowrap;">Source: </label>
      <div class="d-flex align-items-center flex-grow-1" style="text-align: left;">
        <select class="form-control sourceSelect me-2" required #luSourceDropdown name="luSourceDropdown" id="luSourceDropdown" [(ngModel)]="luSourceSelection" [disabled]="working" (ngModelChange)="changeSource($event)">
          <option [ngValue]="null">Choose a source</option>
          <option *ngFor="let s of sourceData" [ngValue]="s">{{ s.source }}</option>
        </select>
        <img *ngIf="!working && luSourceSelection && luSourceSelection.logoPath" [src]="luSourceSelection.logoPath" class="source-logo">
      </div>
      <div class="w-100 mt-2" *ngIf="!callNumberData.length && !working">
        <div class="alert alert-warning mb-0" role="alert">
          <i class="fal fa-exclamation-triangle me-1"></i>Sorry, there is no Call # data associated with that Source.
        </div>
      </div>    
    </div>    
    <div class= "align-items-start mb-3">
      <label for="callL1" class="label me-3" style="white-space: nowrap;">Call numbers: </label>
      <div class="d-flex flex-column flex-grow-1" style="width: 80vw;">
        <select [disabled]="!callNumberData.length" required name="callL1" id="callL1" class="form-control callNumberSelect mb-2" [(ngModel)]="callNumberL1Selection" (change)="changeCallNumberSelections()">
          <option [ngValue]="null">Choose call #</option>
          <option *ngFor="let c of callNumberL1DisplayData" [ngValue]="c.callNumberL1">{{ c.callNumberL1 }}</option>
        </select>
        <select [disabled]="!callNumberL2Data.length" name="callL2" id="callL2" class="form-control callNumberSelect mb-2"
          [(ngModel)]="callNumberL2Selection" (change)="changeCallNumberSelections()">
          <option [ngValue]="null"> {{ callNumberL2Data.length ? 'All' : '--' }} </option>
          <option *ngFor="let c of callNumberL2Data" [ngValue]="c.callNumberL2">{{ c.callNumberL2 }}</option>
        </select>
        <select [disabled]="!callNumberL3Data.length" name="callL3" id="callL3" class="form-control callNumberSelect mb-2" [(ngModel)]="callNumberL3Selection"
          (change)="changeCallNumberSelections()">
          <option [ngValue]="null"> {{ callNumberL3Data.length ? 'All' : '--' }} </option>
          <option *ngFor="let c of callNumberL3Data" [ngValue]="c.callNumberL3">{{ c.callNumberL3 }}</option>
        </select>
        <select [disabled]="!callNumberL4Data.length" name="callL4" id="callL4" class="form-control callNumberSelect" [(ngModel)]="callNumberL4Selection"
          (change)="changeCallNumberSelections()">
          <option [ngValue]="null">{{ callNumberL4Data.length ? 'All' : '--' }}</option>
          <option *ngFor="let c of callNumberL4Data" [ngValue]="c.callNumberL4">{{ c.callNumberL4 }}</option>
        </select>
      </div>
    </div>
    <div class="form-group d-flex align-items-center mb-3">
      <label class="label me-3" style="white-space: nowrap;">Description:</label>
      <div class="sourceDescription mobile flex-grow-1" style="text-align: left;" *ngIf="chosenSourceCallNumberDescription !== ''; else describePlaceholder">
        {{ chosenSourceCallNumberDescription }}
      </div>
      <ng-template #describePlaceholder>
        <div class="sourceDescription mobile text-muted small flex-grow-1" style="text-align: left;">
          Choose a call number to see its description.
        </div>
      </ng-template>
    </div>
  </div>

</ng-template>